import { TApplicationState } from 'shared/types/redux';

export const selectSpecialPromos = (state: TApplicationState) => state.specialPromos;
